"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchTaskMenuItem = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const launch_task_menu_item_styles_1 = require("./launch-task-menu-item.styles");
const ordered_list_icon_component_1 = require("../../../../../../../icons/svg/ordered-list-icon.component");
const LaunchTaskMenuItem = ({ label, isDisabled, }) => (react_1.default.createElement(launch_task_menu_item_styles_1.LaunchTaskContent, { "$disabled": isDisabled }, react_1.default.createElement(launch_task_menu_item_styles_1.LaunchTaskLabel, null, react_1.default.createElement(ordered_list_icon_component_1.OrderedListIcon, null), " ", label), isDisabled && react_1.default.createElement(material_1.CircularProgress, { size: 12 })));
exports.LaunchTaskMenuItem = LaunchTaskMenuItem;
